import React, {Component} from 'react'
import Testimonial from "../models/Testimonial";

export default function TestimonialComponent(props: {testimonial: Testimonial}) {
  let stars = <li><i className="fas fa-star"></i></li>;
  for (let i = 0; i < props.testimonial.stars; i++)
    stars = <>{stars} <li><i className="fas fa-star"></i></li></>

  return (
    <div className="swiper-slide">


      <div className="art-a art-testimonial">

        <div className="testimonial-body">

          <img className="art-testimonial-face" src={props.testimonial.avatar} alt="face"/>

          <h5>{props.testimonial.name}</h5>
          <div className="art-el-suptitle mb-15">{props.testimonial.profession}</div>

          <div className="mb-15">{props.testimonial.description}</div>
        </div>

        <div className="art-testimonial-footer">
          <div className="art-left-side">

            <ul className="art-star-rate">
              {stars}
            </ul>

          </div>
          <div className="art-right-side">

          </div>
        </div>

      </div>


    </div>
  )
}

/*export default class TestimonialComponent extends Component {
  render() {
    return (
      <></>
    )
  }
}*/
